<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="考试名称:">
          <el-select v-model="listQuery.exam_id" clearable placeholder="请选择" @change="getStations">
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考站名称:">
          <el-select v-model="listQuery.station_id" clearable placeholder="请选择">
            <el-option
              v-for="item2 in stationList"
              :key="item2.id"
              :label="item2.name"
              :value="item2.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="考生名称:">
          <el-input v-model="listQuery.name" clearable placeholder="考生名称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column label="考试名称">
        <template slot-scope="scope">
          {{scope.row.exam_name}}
        </template>
      </el-table-column>
      <el-table-column prop="station_name" label="考站名称">
      </el-table-column>
      <el-table-column prop="student_name" label="考生姓名">
      </el-table-column>
      <el-table-column prop="begin_dt" label="开始时间">
      </el-table-column>
      <el-table-column prop="time" label="用时">
      </el-table-column>
      <el-table-column prop="score" label="成绩">
      </el-table-column>
      <el-table-column label="评分老师">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope)">{{scope.row.teacher_name}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- v-if="pageform.total>pageform.pageSize" -->

    <div style="text-align: right;margin-top:20px">

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.per_page"
                  @pagination="getData"/>

    </div>
<!--    <el-dialog :visible.sync="dialogVisible" :title="dialogType==='edit'?'编辑考官':'新增考官'">-->
<!--      <el-form :model="student" label-width="80px" label-position="left">-->
<!--        <el-form-item label="姓名" prop="name">-->
<!--          <el-input v-model="student.name" placeholder="姓名"/>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="手机号" prop="mobile">-->
<!--          <el-input v-model="student.mobile" placeholder="手机号"/>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="手机号" prop="mobile">-->
<!--          <el-input v-model="student.mobile" placeholder="手机号"/>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
<!--      <div style="text-align:right;">-->
<!--        <el-button type="danger" @click="dialogVisible=false">取消</el-button>-->
<!--        <el-button type="primary" @click="confirmSave">保存</el-button>-->
<!--      </div>-->
<!--    </el-dialog>-->

  </div>
</template>

<script>
    import Pagination from '../../components/Pagination'

    export default {
        components: {Pagination},
        props: {},
        data() {
            return {
                student: {},
                examList: [],
                stationList: [],
                total: 0,
                dialogType: 'new',
                dialogVisible: false,
                listQuery: {
                    page: 1,
                    per_page: 20,
                    include: 'exam,station,student,teacher',
                    exam_id:null,
                    station_id:null,
                    name:null
                },
                tableData: []
            };
        },
        computed: {

        },
        mounted() {
            this.getData();
            this.getExams();
            this.getStations()
        },
        methods: {
            getStations() {
                this.$http.getExamResultStations({exam_id: this.listQuery.exam_id}).then(res => {
                    this.stationList = res.data;
                })
            },
            getExams() {
                this.$http.getAllExam().then(res => {
                    this.examList = res.data;
                })
            },
            search() {
                this.listQuery.page = 1;
                this.getData()
            },
            getData() {
                this.$http.getExamResults(this.listQuery)
                    .then(res => {
                        this.tableData = res.data;
                        this.total = res.meta.total;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            handleDetail(scope) {
                this.$router.push({name:'scoreResult',query:{id:scope.row.id}})
            },
            confirmSave() {
                const isEdit = this.dialogType === 'edit'
                if (isEdit) {
                    this.$http.updateTeacher(this.student.id, this.student).then(res => {
                        this.dialogVisible = false
                        this.$notify({
                            title: 'Success',
                            message: '操作成功！',
                            type: 'success'
                        })
                        this.getData()
                    })
                } else {
                    this.$http.addTeacher(this.student).then(res => {
                        this.dialogVisible = false
                        this.$notify({
                            title: 'Success',
                            message: '操作成功！',
                            type: 'success'
                        })
                        this.getData()
                    })
                }
            },
            handleDelete({$index, row}) {
                this.$confirm('确定要删除此条吗?', '警告', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http.deleteTeacher(row.id).then(res => {
                            this.tableData.splice($index, 1)
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                        });

                    })
                    .catch(err => {
                        console.error(err)
                    })
            },

        },
    };
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/page/examManage/examResults.vue